<div class="row mt-2">
    <div class="col-md-3">
      <div class="card">
          <div class="card-header">
              <div class="card-title mb-0"><strong>Games Category</strong></div>
          </div>
          <div class="card-body">
              <form #f="ngForm" (ngSubmit)="f.valid && submit()" novalidate>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="code" class="form-label">Title <em>*</em></label>
                            <input type="text" class="form-control" id="name" name="name" #name="ngModel" [(ngModel)]="data.title" required>
                            <div *ngIf="f.submitted && name.invalid" class="invalid-feedback">
                                <div *ngIf="name.errors.required">Name is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="image" class="form-label">Image <em>*</em></label>
                            <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'image', true)" (deleteEvent)="delete($event, 'image')" #imageUploader></app-image-uploader>
                            <!-- <input type="file" (change)="loadFile($event, 'image')" class="form-control" id="image" name="image">
                            <div *ngIf="f.submitted && !data.image" class="invalid-feedback">
                                <div>Image is required</div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="icon" class="form-label">Icon (For Header / Sidebar Menu)</label>
                            <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'icon', true)" (deleteEvent)="delete($event, 'icon')" #iconUploader></app-image-uploader>
<!-- 
                            <div class="row">
                                <div class="col-8">
                                    <input type="file" (change)="loadFile($event, 'icon')" class="form-control" id="icon" name="icon">
                                    
                                    <label for="mbanner" class="form-label">Mobile Slider</label>
                                </div>
                                <div class="col-4">
                                    <div *ngIf="data.icon">
                                        <img [src]="data.icon" class="w-100" />
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="hide_from_menu" class="form-label">Hide from Category Menu</label>
                            <select class="form-control" id="hide_from_menu" name="hide_from_menu" [(ngModel)]="data.hide_from_menu">
                                <option [value]="0">No</option>
                                <option [value]="1">Yes</option>
                            </select>
                            <small class="text-muted">Games in this category can still be selected in promotions.</small>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="code" class="form-label">Is Hot Game</label>
                            <select class="form-control" id="is_hot_game" name="is_hot_game" #is_hot_game="ngModel" [(ngModel)]="data.is_hot_game">
                                <option [value]="1">Yes</option>
                                <option [value]="0">No</option>
                            </select>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="code" class="form-label">Sort</label>
                            <input type="number" class="form-control" id="sort" name="sort" #sort="ngModel" [(ngModel)]="data.sort">
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="footer_note" class="form-label">Category Footer Note</label>
                            <angular-editor id="footer_note" [placeholder]="'Footer Notes'" [(ngModel)]="data.note" ></angular-editor>
                        </div>
                    </div>
                </div>
                  <div class="row">
                      <div class="col-12">
                          <div class="mb-3">
                              <label for="status" class="form-label">Status <em>*</em></label>
                              <select class="form-control" id="status" name="status" #status="ngModel" [(ngModel)]="data.status" required>
                                  <option [value]="1">Active</option>
                                  <option [value]="0">Disabled</option>
                              </select>
                              <div *ngIf="f.submitted && status.invalid" class="invalid-feedback">
                                  <div *ngIf="status.errors.required">Status is required</div>
                              </div>
                          </div>
                      </div>
                  </div>
                  <hr/>
                  <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="feature_image" class="form-label">Feature Image</label>
                            <app-image-uploader [type]="'single'" (uploadEvent)="upload($event, 'feature_image', true)" (deleteEvent)="delete($event, 'feature_image')" #featureUploader></app-image-uploader>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="feature_status" class="form-label">Feature Status</label>
                            <select class="form-control" id="feature_status" name="feature_status" #feature_status="ngModel" [(ngModel)]="data.feature_status" >
                                <option [value]="1">Active</option>
                                <option [value]="0">Disabled</option>
                            </select>
                            <div *ngIf="f.submitted && feature_status.invalid" class="invalid-feedback">
                                <div *ngIf="feature_status.errors.required">Feature Status is required</div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <div class="mb-3">
                            <label for="feature_sort" class="form-label">Feature Sort</label>
                            <input type="number" class="form-control" id="feature_sort" name="feature_sort" #feature_sort="ngModel" [(ngModel)]="data.feature_sort">
                        </div>
                    </div>
                </div>
                  <button type="submit" class="btn btn-primary">Update</button>
              </form>
          </div>
      </div>
    </div>
  </div>